import { useEffect, useState } from "react";
import api, { apiError } from "../lib/api";
import { fmtIDR } from "../lib/format";
import { Sparkles, RefreshCw, Loader2, CalendarDays } from "lucide-react";
import { toast } from "sonner";

export default function DailyRecap() {
  const [recaps, setRecaps] = useState([]);
  const [loading, setLoading] = useState(false);
  const load = () => api.get("/daily-recaps").then((r) => setRecaps(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const generate = async () => {
    setLoading(true);
    try { await api.post("/daily-recaps/generate"); toast.success("Recap hari ini dibuat"); load(); }
    catch (e) { toast.error(apiError(e)); } finally { setLoading(false); }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2"><CalendarDays className="h-6 w-6 text-[#EAB308]" /><h1 className="font-head text-2xl font-bold">Daily Recap</h1></div>
        <button className="btn-outline flex items-center gap-2" data-testid="generate-recap-btn" onClick={generate} disabled={loading}>
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <RefreshCw className="h-4 w-4" />} Buat Hari Ini
        </button>
      </div>
      <p className="text-sm text-[#64748B]">Ringkasan otomatis dibuat setiap malam pukul 21:00 WIB.</p>

      {recaps.length === 0 ? (
        <div className="nnx-card p-8 text-center text-[#64748B]" data-testid="no-recaps">Belum ada recap. Klik "Buat Hari Ini".</div>
      ) : (
        <div className="space-y-3" data-testid="recap-list">
          {recaps.map((r) => (
            <div key={r.biz_date} className="nnx-card p-5" data-testid={`recap-${r.biz_date}`}>
              <div className="flex items-center justify-between mb-3">
                <div className="font-head font-bold text-lg">{r.biz_date}</div>
                <span className="mono text-[#EAB308] font-bold">{fmtIDR(r.net_after_expenses)} net</span>
              </div>
              {r.ai_summary && (
                <div className="flex gap-2 text-sm bg-[#0B0E14] border border-[#222B3D] rounded-lg p-3 mb-3">
                  <Sparkles className="h-4 w-4 text-[#EAB308] shrink-0 mt-0.5" />
                  <span className="text-[#CBD5E1]">{r.ai_summary}</span>
                </div>
              )}
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm">
                <Cell l="Transaksi" v={r.summary.count} />
                <Cell l="Volume" v={fmtIDR(r.summary.volume)} />
                <Cell l="Profit Kotor" v={fmtIDR(r.summary.gross_profit)} />
                <Cell l="Expenses" v={fmtIDR(r.expenses)} />
                <Cell l="Nilai Inventory" v={fmtIDR(r.inventory_value)} gold />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function Cell({ l, v, gold }) {
  return <div><div className="label">{l}</div><div className={`mono font-bold mt-0.5 ${gold ? "text-[#EAB308]" : ""}`}>{v}</div></div>;
}
